import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class PickJobGroupService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 2165
     * @datataskName sp_ws_p2_w_pickjobgrps_list
     * @param params
     * @returns promise containing list of pick job groups.
     */
    public async getPickJobGroups(params: GetPickJobGroupsParams): Promise<PickJobGroupItem[]> {
        return this.datatask.Post(2165, params);
    }
}

export interface GetPickJobGroupsParams {
    stockplace_id: string;
}

export interface PickJobGroupItem {
    item_id: string;
    item_name: string;
    item_state: string;
    item_parms: string;
    item_path: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
    orderby: string;
    item_name_sub1: string;
    item_filtervalue: string;
}
